import { ApplicationConfig, LOCALE_ID, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideTranslateService } from "@ngx-translate/core";
import { provideHttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import localeRo from '@angular/common/locales/ro';
import { registerLocaleData } from '@angular/common';

import { routes } from './app.routes';
import { provideServiceWorker } from '@angular/service-worker';

registerLocaleData(localeRo);

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideAnimations(),
        provideHttpClient(),
        provideTranslateService({
            defaultLanguage: 'en'
        }),
        { provide: LOCALE_ID, useValue: 'ro-RO' },
        DatePipe, provideServiceWorker('ngsw-worker.js', {
            // enabled: !isDevMode(),
            
            enabled: false,
            registrationStrategy: 'registerWhenStable:30000'
          })
    ]
};
